import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable prettier/prettier */

import React, { useState } from 'react';
import { Row, Col, Icon, Dropdown, Tooltip, Menu, Select, Badge, Avatar } from 'antd';
import MUser from '../MUser/MUser';
import Alerts from '../Alerts/Alerts'; // @ts-ignore

/* babel-plugin-inline-import '../assets/images/LogoCorreos2019_Azul.svg' */

var LogoCorreos = "data:image/svg+xml;base64,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";
import { Link } from 'react-router-dom';
import 'moment/locale/es';
import { withTranslation } from 'react-i18next';
import { storeArq } from 'correos-arq-utils';
var Option = Select.Option;
var SubMenu = Menu.SubMenu;
;

var Header = function Header(myprops) {
  try {
    var pathHelp = "#";

    if (myprops.pathHelp) {
      pathHelp = myprops.pathHelp;
    }

    var t = myprops.t,
        clickHome = myprops.clickHome,
        clickMenu = myprops.clickMenu,
        i18n = myprops.i18n,
        logoutSys = myprops.logoutSys;
    storeArq.load();

    require('dotenv').config();

    var _useState = useState('es'),
        _useState2 = _slicedToArray(_useState, 2),
        language = _useState2[0],
        setLanguage = _useState2[1];
    /* Logo y nombre de aplicacion (name)
    + barra de herramientas (notif, home y ayuda)
    + dropdown auto --> MUser, responsive con el sistema Grid
    
    Si estas autenticado aparecerá el menu usuario con sus respectivos datos
    y el logo redicionando a al inicio ,en caso negativo, en el menu usuario no aparecerá nada
    y en el logo NO redicionará a al inicio */


    var changeLanguageMenu = function changeLanguageMenu(lng) {
      i18n.changeLanguage(lng);
    };

    var changeLanguageSelect = function changeLanguageSelect(value) {
      i18n.changeLanguage(value);
      setLanguage(value);
    };

    var getCurrentLng = function getCurrentLng() {
      return i18n.language || window.localStorage.i18nextLng || language || '';
    };

    var altProp = t('components_shared_Header.imgAlt');
    var headerAuth;
    var menu = /*#__PURE__*/React.createElement(Menu, {
      className: "Menu"
    }, /*#__PURE__*/React.createElement(SubMenu, {
      className: "Items",
      title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        type: "flag"
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: '0.125em',
          marginRight: '0.4em'
        }
      }, t('components_shared_Header.iconsTooltip.4')))
    }, /*#__PURE__*/React.createElement(Menu.Item, {
      onClick: function onClick() {
        return changeLanguageMenu('es');
      }
    }, t('components_shared_Header.lenguages.spanish')), /*#__PURE__*/React.createElement(Menu.Item, {
      onClick: function onClick() {
        return changeLanguageMenu('en');
      }
    }, t('components_shared_Header.lenguages.english'))), /*#__PURE__*/React.createElement(SubMenu, {
      className: "Items",
      title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        type: "bell"
      }), /*#__PURE__*/React.createElement("span", null, t('components_shared_Header.iconsTooltip.0')))
    }, /*#__PURE__*/React.createElement(Menu.Item, null, t('components_shared_Alerts.titles.0')), /*#__PURE__*/React.createElement(Menu.Item, null, t('components_shared_Alerts.titles.1'))), /*#__PURE__*/React.createElement(Menu.Item, {
      key: "2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "Items"
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "home",
      style: {
        marginRight: '0.53em'
      }
    }), /*#__PURE__*/React.createElement(Link, {
      to: "/",
      onClick: function onClick() {
        clickHome(true);
        clickMenu && clickMenu(); // @ts-ignore

        storeArq.data.auth.userInfo.subMenu = {};
        storeArq.save();
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        color: 'rgba(0,0,0,.65)'
      }
    }, t('components_shared_Header.iconsTooltip.1'))))), /*#__PURE__*/React.createElement(Menu.Item, {
      key: "3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "Items"
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "question-circle",
      style: {
        marginRight: '0.53em'
      }
    }), /*#__PURE__*/React.createElement(Link, {
      to: pathHelp,
      target: "_blank"
    }, /*#__PURE__*/React.createElement("span", null, t('components_shared_Header.iconsTooltip.2'))))));

    if (storeArq.data.auth.token !== '') {
      headerAuth = /*#__PURE__*/React.createElement(Row, {
        className: "Head"
      }, /*#__PURE__*/React.createElement(Col, {
        span: 1
      }), /*#__PURE__*/React.createElement(Col, {
        xs: 14,
        sm: 14,
        md: 14,
        lg: 15,
        xl: 16,
        xxl: 16
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/",
        onClick: function onClick() {
          clickHome(true);
          clickMenu && clickMenu(); // @ts-ignore

          storeArq.data.auth.userInfo.subMenu = [];
          storeArq.save();
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: LogoCorreos,
        alt: altProp,
        className: "Logo"
      })), /*#__PURE__*/React.createElement("p", {
        className: "overflowTitle"
      }, t('App.title'))), /*#__PURE__*/React.createElement(Col, {
        xs: 7,
        sm: 7,
        md: 7,
        lg: 6,
        xl: 5,
        xxl: 6,
        align: "right"
      }, /*#__PURE__*/React.createElement("div", {
        className: "icons overflowIcon"
      }, /*#__PURE__*/React.createElement(Tooltip, {
        placement: "left",
        title: t('components_shared_Header.iconsTooltip.4')
      }, /*#__PURE__*/React.createElement(Select, {
        value: getCurrentLng(),
        onChange: changeLanguageSelect,
        className: "SelectIdiom visible"
      }, /*#__PURE__*/React.createElement(Option, {
        value: "es"
      }, t('components_shared_Header.lenguages.spanish')), /*#__PURE__*/React.createElement(Option, {
        value: "en"
      }, t('components_shared_Header.lenguages.english')))), /*#__PURE__*/React.createElement(Dropdown, {
        overlay: /*#__PURE__*/React.createElement(Alerts, null)
      }, /*#__PURE__*/React.createElement(Tooltip, {
        placement: "bottom",
        title: t('components_shared_Header.iconsTooltip.0')
      }, /*#__PURE__*/React.createElement(Badge, {
        count: 3,
        className: "Notification visible"
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "Bell",
        type: "bell"
      })))), /*#__PURE__*/React.createElement(Tooltip, {
        placement: "bottom",
        title: t('components_shared_Header.iconsTooltip.1')
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/",
        onClick: function onClick() {
          clickHome(true);
          clickMenu && clickMenu(); // @ts-ignore

          storeArq.data.auth.userInfo.subMenu = {};
          storeArq.save();
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "iconos visible",
        type: "home"
      }))), /*#__PURE__*/React.createElement(Tooltip, {
        placement: "bottom",
        title: t('components_shared_Header.iconsTooltip.2')
      }, /*#__PURE__*/React.createElement(Link, {
        to: pathHelp,
        target: "_blank"
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "iconos visible",
        type: "question-circle"
      }))), /*#__PURE__*/React.createElement(Dropdown, {
        overlay: menu
      }, /*#__PURE__*/React.createElement(Tooltip, {
        placement: "left",
        title: t('components_shared_Header.iconsTooltip.5')
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "Burguer",
        type: "bars"
      }))))), /*#__PURE__*/React.createElement(Col, {
        xs: 2,
        sm: 2,
        md: 2,
        lg: 1,
        xl: 1,
        xxl: 1,
        align: "left"
      }, /*#__PURE__*/React.createElement("div", {
        className: "icons-user"
      }, /*#__PURE__*/React.createElement(Dropdown, {
        overlay: /*#__PURE__*/React.createElement(MUser, {
          logoutSys: logoutSys
        })
      }, /*#__PURE__*/React.createElement(Tooltip, {
        placement: "bottom",
        title: t('components_shared_Header.iconsTooltip.3')
      }, /*#__PURE__*/React.createElement("div", {
        className: "BoxAvatar"
      }, /*#__PURE__*/React.createElement("div", {
        className: "Line"
      }), /*#__PURE__*/React.createElement(Avatar, {
        style: {
          backgroundColor: '#0066FF',
          cursor: 'pointer'
        },
        icon: "user",
        className: "iconos-user",
        size: 25
      })))))), /*#__PURE__*/React.createElement(Col, {
        span: 1
      }));
    } else {
      headerAuth = /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        span: 1
      }), /*#__PURE__*/React.createElement(Col, {
        span: 22
      }, /*#__PURE__*/React.createElement("img", {
        src: LogoCorreos,
        alt: altProp,
        className: "Logo"
      }), /*#__PURE__*/React.createElement("p", {
        className: "overflowTitle"
      }, t('App.SinAuth') + " " + t('App.title'))), /*#__PURE__*/React.createElement(Col, {
        span: 1
      }));
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "header"
    }, headerAuth);
  } catch (error) {
    throw new Error("Error: ".concat(error));
  }
};

export default withTranslation()(Header);